import { useDispatch, useSelector } from '@redux';
import crudSelectors from '@redux/crudSelectors';
import { AutoComplete, Button, Form, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmBatchModal from './Modal/ConfirmBatchModal';
import { debounce } from 'lodash';
import crudActions from '@redux/crudActions';
import { useGetFilter } from 'hooks/useSearchParamsObj';

const BATCH_QUANTITY = [
  {
    value: 25,
  },
  {
    value: 50,
  },
  {
    value: 75,
  },
  {
    value: 100,
  },
];

const ButtonCreateBatch = ({ listReft }) => {
  const dispatch = useDispatch();

  const { searchParams, setSearchParams } = useGetFilter();

  const total = useSelector<number>(
    crudSelectors['transferConfirmedPick'].getTotal,
  );

  const [form] = Form.useForm();

  const { t } = useTranslation();

  const listIds = useSelector<{ id: string }[]>(
    crudSelectors['transferConfirmedPick'].getDataArr,
  );

  const selectedRowKeys = useSelector<any[]>(
    crudSelectors.transferConfirmedPick.getSelectedRowKeys,
  );

  const [confirmListModal, setConfirmListModal] = useState<boolean>(false);

  const handleCloseConfirmBatchModal = () => {
    searchParams.delete('q');
    searchParams.delete('fieldSearch');
    setSearchParams(searchParams);
    setConfirmListModal(false);
  };

  const handleSelectOrderBatch = (e) => {
    if (Number(e) > total) {
      return;
    } else if (Number(e) <= total) {
      const data = listIds
        .slice(0, Number(e))
        ?.map((item: { id: string }) => item?.id);
      listReft?.current?.handleSelectRows(data);
      dispatch(
        crudActions.transferConfirmedPick.setSelectedRowKeys(data as any),
      );
    }
  };

  const onChangeDebounce = debounce((value) => {
    handleSelectOrderBatch(value);
  }, 300);

  useEffect(() => {
    if (total || selectedRowKeys?.length) {
      form.setFieldsValue({
        quantity: selectedRowKeys?.length || 0,
      });
    }
    // eslint-disable-next-line
  }, [total, selectedRowKeys?.length]);

  return (
    <>
      <Form form={form} onFinish={() => {}}>
        <div className="flex items-center justify-end mb-5">
          <Space size={14} align="center">
            <div className="flex items-center py-[5px] pl-2.5 pr-[5px] border rounded-[5px] border-[#EFEFEF] bg-[#FFFFFF]">
              <div className="mr-2.5 text-[#2C3546] font-[500px]">
                Orders per batch
              </div>
              <Form.Item
                name="quantity"
                // noStyle
                normalize={(e) => Number(e) || 0}
                style={{ marginBottom: 0 }}
                rules={[
                  {
                    type: 'number',
                    message: t('orders.batch.number'),
                  },
                  () => ({
                    validator(_, value) {
                      if (value <= total) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(t('orders.batch.max', { max: total })),
                      );
                    },
                  }),
                ]}
              >
                <AutoComplete
                  style={{
                    minWidth: 52,
                    height: 'auto',
                    borderColor: '#6852D3',
                    color: '#6852D3',
                  }}
                  options={[...BATCH_QUANTITY, { value: total }]}
                  // disabled={!total || selectedRowKeys?.length > 0}
                  onChange={(e) => {
                    onChangeDebounce(e);
                  }}
                />
              </Form.Item>
            </div>
            <Button
              className="btn-primary"
              type="primary"
              disabled={total <= 0 || selectedRowKeys?.length <= 0}
              onClick={() => setConfirmListModal(true)}
            >
              {t('orders.createBatch')}
            </Button>
          </Space>
        </div>
      </Form>
      <ConfirmBatchModal
        visible={confirmListModal}
        onCancel={handleCloseConfirmBatchModal}
        transferOrdersSelected={selectedRowKeys}
      />
    </>
  );
};

export default ButtonCreateBatch;
